module.exports = __webpack_public_path__ + "static/img/wechat-qr@2x.ab26a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/wechat-qr@2x.png
// module id = n2cL
// module chunks = 13